import { FC, useRef } from "react";
import { useOnScreen } from "common/hooks/useOnScreen";
import { FixedVideo, Caption, Video, VideoWrapper } from "./JwPlayer.styled";

type Props = {
  url?: string;
  caption?: string;
};

const JwPlayer: FC<Props> = ({ url, caption }) => {
  const ref: any = useRef<HTMLDivElement>();
  const onScreen: boolean = useOnScreen<HTMLDivElement>(ref, "0px");

  if (!url) {
    return null;
  }

  return (
    <>
      <VideoWrapper>
        <Video
          ref={ref}
          src={url}
          width="100%"
          height="100%"
          controls
          autoPlay
          muted
          loop
        />
      </VideoWrapper>
      <Caption>{caption}</Caption>
      {!onScreen && ref.current && (
        <FixedVideo src={url} controls autoPlay muted />
      )}
    </>
  );
};

export default JwPlayer;
